import { ShinkansenMixerApi } from '@linktivity/triplabo-shinkansen';
import config from '../config';

const shinkansenApi = new ShinkansenMixerApi(config);

export default shinkansenApi;
